export interface CarnetRespondeModel {
  AsesorGestion: number;
  AsesorPoblacion: number;
  ContratoAfiliado: string;
  DescripcionPlan: string;
  FechaNacimiento: string;
  FechaInicio: string;
  NumeroUsuario: string;
  Plan: string;
  Telefono: string;
  VigenciaPlan: string;
  cobertura: string;
  credencial: string;
  franquicia: string;
  identificacion: string;
  nombre: string;
  tipoPlan: string;
  Carnet: string;
  selected?: boolean;
  nombreColectivo: string;   // Añadido
  numeroConsecutivo: string; // Añadido
  Linea: string;             // Añadido
  Email: string;             // Añadido
  vigen_desde: number;       // Añadido
  imagen: string; //imgfondo base64
}

export class CarnetRequestModel {
  nombreClave: string = "";
  jsonParametros: string = "";
}

export class CarnetModel {
  typeDocument: string = "";
  identification: string = "";
  identificationAsesor: string = "";
  typeAsesor: string = "";
}

export class CarnetImgModel {
  planCarnet: string = "";
}

export class JsonRespuestaCarnet {
  status: boolean = false;
  message: string = "";
  errorMessage: string = "";
  codeStatus: string = "";
  data: CarnetRespondeModel[] = [];
}

export class jsonRespuesta {
  nombre: string = "";
  identificacion: string = "";
  ContratoAfiliado: string = "";
  NumeroUsuario: string = "";
  credencial: string = "";
  Plan: string = "";
  DescripcionPlan: string = "";
  Telefono: string = "";
  FechaNacimiento: string = "";
  VigenciaPlan: string = "";
  Email: string = "";
  AsesorGestion: number = 0;
  AsesorPoblacion: number = 0;
}